/* MUI */
import { Box } from '@mui/material';

/* React */
import React from 'react';

/* Internal Components */
import { UserDetailsAppHeadlineCard } from './UserDetailsAppHeadlineCard';
import { UserDetailsContractDetails } from './UserDetailsContractDetails';
import { UserDetailsContractUsersTable } from './UserDetailsContractUsersTable';

export const UserDetailsAppInfo = ({ contract }) => (
    <Box data-testid="userDetailsAppInfo" className="break-after">
        <UserDetailsAppHeadlineCard app={contract.application} />
        <UserDetailsContractDetails contract={contract} />
        {contract.users?.length > 0 && (
            <Box
                className="noBreak"
                data-testid="userDetailsContractUsersTable"
                p="24px"
            >
                <UserDetailsContractUsersTable users={contract.users} />
            </Box>
        )}
    </Box>
);
